export type viewT = {
    key: string;
    name: string;
}

export let views: viewT[] = [
    {
        key: 'Plan',
        name: 'Plan',
    },
    {
        key: 'SideA',
        name: 'Front (A)',
    },
    {
        key: 'SideC',
        name: 'Back (C)',
    },
    {
        key: 'SideD',
        name: 'Left (D)',
    },
    {
        key: 'SideB',
        name: 'Right (B)',
    },
]
